/**
 * Icon Sizes
 * 
 * Provides consistent icon sizing for atomic components.
 * The tenant system doesn't have icon size scales.
 * 
 * Note: Scaled up to match larger typography throughout the page.
 */
export const iconSizes = {
  /** 12px - Extra small icons (e.g., badge icons) */
  xs: '12px',
  /** 18px - Small icons */
  sm: '18px',
  /** 19px - Small-medium icons for compact displays */
  smMd: '19px',
  /** 22px - Medium-large icons for card displays */
  mdLg: '22px',
  /** 24px - Medium icons (e.g., utility icons) */
  md: '24px',
  /** 28px - Large icons */
  lg: '28px',
  /** 32px - Extra large icons */
  xl: '32px',
  /** 40px - Extra extra large icons (e.g., tab icons) */
  xxl: '40px',
} as const;

export type IconSizes = typeof iconSizes;
